import { render, staticRenderFns } from "./Fudao.vue?vue&type=template&id=160dfb26&scoped=true&"
import script from "./Fudao.vue?vue&type=script&lang=js&"
export * from "./Fudao.vue?vue&type=script&lang=js&"
import style0 from "./Fudao.vue?vue&type=style&index=0&id=160dfb26&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160dfb26",
  null
  
)

export default component.exports